/**
 * `codelist_activity_close_reason` is hand-maintained (see
 * `database/seed/common/080_activity_close_reason.sql`), not part of the JSON codelist canon, but
 * it reads through the same generic `CodelistControllerApi.getCodelist` endpoint and row shape as
 * any other codelist table.
 */
export const CLOSE_REASON_CODELIST_TABLE = "codelist_activity_close_reason";
/** The original Raise Query activity-type picker uses the same generic codelist endpoint. */
export const QUERY_ACTIVITY_TYPE_SOURCE = "codelist_activity_type";

/** Row keys `getCodelist` returns for this table — the same three every `codelist_value`/`display_status` table has. */
export const CLOSE_REASON_ROW_KEYS = {
  id: "id",
  value: "codelist_value",
  status: "display_status",
} as const;

/** The one `display_status` value that marks a row selectable for a new close (server convention: anything else is retired). */
export const CLOSE_REASON_ACTIVE_STATUS = "Yes";
